import AchievementsDataset from "../datasets/achievements_dataset";
import processAchievementCriteriaArr from "../../../objects/CommonUse/process_achievement_criteria_arr";
import determineAchievementTextLine from "./determine_achievement_text_line";
import determineAchievementMonthsText from "./determine_achievement_months_text";

export const determineAchievementStatus = (achievementID, gameData, savingsInfo, creditCardActive,
    creditCardBalance, investmentActive, summaryInvestments, investmentMaster, nbrMonthsPlayed, 
    creditScore, unlockedFeatures, gameDataAchievement, moneyMgmtTestArr) => {
          
    const achievementInfo = AchievementsDataset.find(elem => elem.achievementID === achievementID);
     
    let checkAmountArr = [];
    if (achievementInfo){
        checkAmountArr = processAchievementCriteriaArr(achievementInfo.criteriaArr, "getText", 
            gameData, savingsInfo, creditCardBalance, summaryInvestments, investmentMaster,
            nbrMonthsPlayed, creditScore, moneyMgmtTestArr, creditCardActive, investmentActive,
            unlockedFeatures);
    }else{
        return "";
    }
    let textArr = [];
    let featureUnlocked = true;
    let featureEarned = true;
    //  if the amount is N/A it means that there is no data for this amount (ex:  No credit card activated);
    for (let i=0; i<checkAmountArr.length; i++){
        const checkAmtObj = checkAmountArr[i];
        const unlockedFeature = checkAmtObj.unlockedFeaturesObj;
        const newTextLine = determineAchievementTextLine(checkAmtObj.checkAmount, checkAmtObj.criteria,
            checkAmtObj.additionalText, checkAmtObj.earnedAchievement, unlockedFeature.featureDisplayName, 
            unlockedFeature.featureUnlocked, unlockedFeature.unlockedFeatureFound, 
            unlockedFeature.featureActive, checkAmtObj.criteriaAmount);
        if (newTextLine.textColor === "black"){
            featureEarned = false;
        }
        textArr.push(newTextLine);
        if (achievementInfo.monthCriteria.monthType !== "none"){
            const monthTextLine = determineAchievementMonthsText(gameDataAchievement, 
                achievementInfo.monthCriteria, achievementID, nbrMonthsPlayed, "awardInfo");
            textArr.push(monthTextLine);
            if (monthTextLine.textColor === "black"){
                featureEarned = false;
            }
        }
       
        let featureCheck = checkAmtObj.unlockedFeaturesObj.featureUnlocked;
        if (featureCheck === false && featureUnlocked === true){
            featureUnlocked = false;
        }
    }

    let earnedText = "";
    if (featureEarned === true){
        earnedText = "You have met all of the conditions for this award, you will earn the " +
                "award when this turn ends (all cards in the hand are played).";
    }
       
    let linkText = "";
    let link = "";
    if (achievementInfo.link !== ""){
        link = achievementInfo.link;
        linkText = "Click on the link below "
        if (achievementInfo.linkSelect && achievementInfo.linkSelect !== ""){
            linkText += " and select the ";
            let buttonWord = ""; 
            if (featureUnlocked === false){ 
                linkText += " 'Check' button on "
            }else{
                buttonWord = " button"
            }
            linkText += achievementInfo.linkSelect + buttonWord + " to learn more.";
        }else{
            linkText += " to learn more."
        }
    }
    
    const returnObj = {textArr: textArr, linkName: link, linkText: linkText, earnedText: earnedText};
    return returnObj;
}
export default determineAchievementStatus;

